export const CALL_TIMER_HEIGHT = 32;
export const CALL_TIMER_VERTICAL_PADDING = 16;
